// src/store.ts
import {configureStore} from '@reduxjs/toolkit';
import counterReducer from './features/counter/counterSlice';
import themeReducer from './features/theme/themeSlice';
import userReducer from './features/user/userSlice';
import tasksReducer from './features/tasks/tasksSlice';

export const store = configureStore({
    reducer: {
        counter: counterReducer,
        theme: themeReducer,
        user: userReducer,
        tasks: tasksReducer,
    },
});

// 🔒 Types utilitaires pour TypeScript :
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
